import { formatNumeric, netejaNumero } from '@common/utils'

const Noticia = ({ taulesPremis, premis }) => {
	return (
		<div id='taula_grossa'>
			{taulesPremis.map(({ title, key, import: quantitats, includeLastDigit }, index) => {
				const val = premis[key]
				return (
					<div className='taula' key={index}>
						<div className='titol'>
							<div className='l1'>{title}</div>
							<div className='l2'>per € jugat</div>
							<div className='l2'>per bitllet</div>
						</div>
						{/* Número principal */}
						<div>
							<div className='l5'>{formatNumeric(val)}</div>
							<div className='l3'>{quantitats[0][0]}</div>
							<div className='l3'>{quantitats[0][1]}</div>
						</div>
						{/* Número -1 */}
						<div>
							<div className='l5'>{formatNumeric(netejaNumero(val) - 1)}</div>
							<div className='l3'>{quantitats[1][0]}</div>
							<div className='l3'>{quantitats[1][1]}</div>
						</div>
						{/* Número +1 */}
						<div>
							<div className='l5'>{formatNumeric(netejaNumero(val) + 1)}</div>
							<div className='l3'>{quantitats[2][0]}</div>
							<div className='l3'>{quantitats[2][1]}</div>
						</div>
						{/* Acabats en */}
						{[1, 2, 3].map((pos, i) => (
							<div key={pos}>
								<div className='l5'>Acabats en {val?.substring(pos)}</div>
								<div className='l3'>{quantitats[i + 3][0]}</div>
								<div className='l3'>{quantitats[i + 3][1]}</div>
							</div>
						))}
						{/* Últim dígit només si aplica */}
						{includeLastDigit && (
							<div>
								<div className='l5'>Acabats en {val?.substring(4)}</div>
								<div className='l3'>{quantitats[6][0]}</div>
								<div className='l3'>{quantitats[6][1]}</div>
							</div>
						)}
					</div>
				)
			})}
		</div>
	)
}
export default Noticia
